import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sendConfigure",
  "use": "icon-sendConfigure-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sendConfigure\"><defs><style type=\"text/css\"></style></defs><path d=\"M669.728 960.512L450.112 782.08l60.8-74.08 110.464 89.824L766.08 350.72 376.064 755.328V955.68h-96V716.864L703.04 278.048 241.056 475.904l95.104 83.776-63.712 71.552L64 447.648 960 64z\" p-id=\"3914\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol